"use client";
import Alert, { type AlertProps } from "@mui/material/Alert";

export interface FormErrorProps extends AlertProps {
  message: string;
}

export default function FormError(props: FormErrorProps) {
  const { message, ...alertProps } = props;

  return (
    <Alert severity="error" {...alertProps}>
      {message}
    </Alert>
  );
}
